import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import useRoutes from "./routes";
import { useUsersContext } from "../context/usersContext";
import localforage from "localforage";
import { Link } from "react-router-dom"; // For navigation link
import { useUserInfo } from "../context/user";

export default function App() {
    const routes = useRoutes();
    const location = useLocation(); // Hook to get the current location
    const { checkfreetrial } = useUsersContext();
    const [showModal, setShowModal] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const userActiveLocation = useUserInfo()[4];
    const activeplans = useUserInfo()[12];

    const appsToMap =
        userActiveLocation?.type === "free"
            ? userActiveLocation?.apps
            : activeplans?.apps;

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!appsToMap) return; // Ensure appsToMap is defined

            // Check if the specific apps exist in appsToMap
            const calendarapp = appsToMap.indexOf("AI Celender App");
            const socialapp = appsToMap.indexOf("AI Social App");

            // Check the path conditions
            const chatapp = location.pathname.includes("chat");
            const calender = location.pathname.includes("calendar");

            // Log the conditions when both chatapp and socialapp are true
            // if (chatapp && socialapp < 0) {
            //     navigate("/app/calendar");
            // }

            // Log the conditions when both calendarapp and calender are true
            if (calendarapp < 0 && calender) {
                navigate("/app/ai-agents");
            }
            if ((calendarapp > -1) && !(chatapp > -1)) {
                navigate("/app/settings");
            }


            // Log the full condition for calendarapp and calender with appsToMap

        }, 3000); // Delay the execution by 3 seconds

        // Cleanup the timeout if the component is unmounted or dependencies change
        return () => clearTimeout(timeout);
    }, [appsToMap, location, navigate]);



    useEffect(() => {
        const handleFreeTrialCheck = async () => {
            try {
                const activeLocation = await localforage.getItem('active_location');
                const result = await checkfreetrial(activeLocation);

                if (result.data?.status === "ended") {
                    const hash = location.hash; // Get the hash part of the URL (e.g., #billing)
                    if (hash === '#billing') {
                        setShowModal(false); // Show modal
                    } else {
                        setMessage(result?.data?.message); // Set the message from response
                        setShowModal(true); // Show modal
                    }

                }
            } catch (error) {
                console.error("Error checking free trial:", error);
            }
        };

        // handleFreeTrialCheck();
    }, [location.pathname, checkfreetrial]);

    // Function to map routes to <Route> components
    const getRoutes = (allRoutes) =>
        allRoutes.map((route) => {
            if (route.route) {
                return <Route exact path={route.route} element={route.component} key={route.key} />;
            }
            return null;
        });

    // Modal Component with inline styles
    const Modal = ({ message, onClose }) => (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
        }}>
            <div style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                width: "400px",
                textAlign: "center"
            }}>
                <div style={{ marginBottom: "20px" }}>
                    <p>{message}</p>
                </div>
                <div>
                    <Link to="/app/settings#billing">
                        <button style={{
                            padding: "10px 20px",
                            margin: "5px",
                            border: "none",
                            backgroundColor: "#007bff",
                            color: "white",
                            cursor: "pointer",
                            borderRadius: "5px",
                            marginRight: "10px"
                        }}>Go to Billing</button>
                    </Link>

                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Routes>
                {getRoutes(routes)}
                <Route path="*" element={<Navigate to="/home" />} />
            </Routes>

            {/* Show Modal if needed */}
            {showModal && <Modal message={message} onClose={() => setShowModal(false)} />}
        </div>
    );
}
